/**
 * `/studio/tasks/$ref` — one task, with everything an agent sees.
 *
 * A route rather than a drawer: `.docs/20` §D asks for "task detail drawer/route",
 * and the review path is what decides it — a `needs_review` notice anywhere in the
 * studio links a task reference, and a link has to have somewhere to go.
 * `TaskRefSchema`'s own shape is the guard.
 *
 * `notFoundComponent` is what keeps the studio around that guard — R3-13, and
 * `notFound.test.tsx` says why it has to be on this route rather than on `/studio`.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../errors/NotFound.js'
import { TaskDetailPage } from '../../../pages/studio/taskDetail/TaskDetailPage.js'

export const Route = createFileRoute('/studio/tasks/$ref')({
  beforeLoad: ({ params }) => {
    if (!isRef('task', params.ref)) throw notFound()
  },
  notFoundComponent: NotFound,
  component: TaskDetailRoute,
})

function TaskDetailRoute() {
  const { ref } = Route.useParams()
  return <TaskDetailPage taskRef={ref} />
}
